module.exports = __webpack_public_path__ + "img/interior-gallery-2.d07e786f.jpg";